module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
(function(fox) {
	
	fox.registerWidget('Model_Browser', {

		configure: function(options) {
			options.dataLayer || (options.dataLayer = {});
			options.dlClass = 'Model';
			this.callParent('configure', arguments);
		},

		init: function() {
			this.callParent('init', arguments);
			return this;
		}
	}, 'Grid');
})(fox);

 /* fox-dynamic-injection */ 
};


//////////////////
// WEBPACK FOOTER
// ./widget/model/browser.js
// module id = 1129
// module chunks = 4